import { render, staticRenderFns } from "./ClientReview.vue?vue&type=template&id=41451382&scoped=true&"
import script from "./ClientReview.vue?vue&type=script&lang=js&"
export * from "./ClientReview.vue?vue&type=script&lang=js&"
import style0 from "./ClientReview.vue?vue&type=style&index=0&id=41451382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41451382",
  null
  
)

export default component.exports